import { StyleSheet } from 'react-native';

import type { useTheme } from '../theme';

// Weight stepper bar (sign toggle + magnitude + plates) (Track R — split from loggerStyles.ts; pure data,
// merged by the loggerStyles barrel). Not imported directly.
export function stepperStyles(theme: ReturnType<typeof useTheme>) {
  const { palette: p, spacing: s, radius: r, typography: t } = theme;
  return StyleSheet.create({
    stepperRow: {
      flexDirection: 'row',
      gap: s.s1,
      paddingHorizontal: s.s1,
    },
    stepperButton: {
      flex: 1,
      minHeight: 36,
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: r.r2,
      borderWidth: 1,
      borderColor: p.border,
      backgroundColor: p.surface2,
    },
    stepperButtonPressed: {
      opacity: 0.6,
    },
    stepperButtonText: {
      color: p.ink2,
      // sm (12): the button is now 36 tall (oversized-UI shrink), so the
      // label drops back to sm to stay proportionate. Touch target held ≥44
      // via hitSlop={8} on the consumer's Pressables.
      fontSize: t.sizes.sm,
      fontWeight: '700',
      fontVariant: ['tabular-nums'],
    },
    stepperButtonSign: {
      // Slightly tighter than the magnitude buttons so the row reads
      // as "[sign] [magnitudes]" instead of six equal cells.
      flex: 0.6,
    },
    stepperButtonSignPositive: {
      backgroundColor: p.surface,
      borderColor: p.ink2,
    },
    stepperButtonTextSignPositive: {
      color: p.ink2,
    },
    // Negative (subtract) mode uses a loud amber 'warn' fill — same treatment
    // as the weight-input signChip — so reduced-vision users can tell at a
    // glance that the magnitude buttons will subtract (per
    // feedback_user_visual_accessibility). Off the brand per the colour budget;
    // the ink comes from inkOnWarn, paired to the
    // warn fill per family (IB-11 — inkOnBrand tracks brand500, not warn).
    stepperButtonSignNegative: {
      backgroundColor: p.warn,
      borderColor: p.warn,
    },
    stepperButtonTextSignNegative: {
      color: p.inkOnWarn,
    },
    stepperButtonPlates: {
      // Neutral helper button (off the brand per the colour budget): opens the
      // plate calculator — a utility, not the screen's primary/live action.
      // Surface2 fill + stronger border keeps it tappable without the orange.
      backgroundColor: p.surface2,
      borderColor: p.borderStrong,
      flex: 1.2,
    },
    stepperButtonTextPlates: {
      color: p.ink2,
      fontSize: t.sizes.xs,
      letterSpacing: 0.3,
      textTransform: 'uppercase',
    },
  });
}
